export default __webpack_public_path__ + "static/1625-0f29d44450eb010a554d5afb80003f3c.gif";